import { reactive } from 'vue'
import { formatDateTimeCN } from '@/utils/datetime'

const appState = reactive({
  isLoading: false,
  lastUpdateTime: '--'
})

export function useAppState() {
  function setLoading(loading: boolean) {
    appState.isLoading = loading
  }

  function setLastUpdateTime(time: string) {
    appState.lastUpdateTime = time
  }

  function updateLastUpdateTime() {
    appState.lastUpdateTime = formatDateTimeCN(new Date())
  }

  return {
    appState,
    setLoading,
    setLastUpdateTime,
    updateLastUpdateTime
  }
}
